import { TimePicker } from 'antd'
import React from 'react'
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';

dayjs.extend(utc);

const TimePickerComponent = ({ onChange }) => {

    const timeChangeHandler = (time) => {
        if (time) {
            const dayjsTime = dayjs(time);
            if (dayjsTime.isValid()) {
                const utcTime = dayjsTime.utc().format('HH:mm');
                onChange(utcTime)
            } else {
                console.error('Invalid time:', time);
            }
        } else {
            console.log('No time selected');
        }
    };

    return (
        <TimePicker onChange={timeChangeHandler} use12Hours format="h:mm:ss A" />
    )
}

export default TimePickerComponent